"use client";

import { useEffect } from "react";

interface AdBannerProps {
    /**
     * Kakao AdFit 광고 단위 ID (예: DAN-xxxxxxxxxxxxxx).
     * 애드핏에서 발급받은 값을 넣어 주세요.
     */
    adSlot: string;
    /** 광고 가로 크기(px). 기본 320 */
    width?: number;
    /** 광고 세로 크기(px). 기본 100 */
    height?: number;
    className?: string;
}

export function AdBanner({ adSlot, width = 320, height = 100, className = "" }: AdBannerProps) {
    useEffect(() => {
        if (!adSlot || adSlot.startsWith("REPLACE_")) return;

        const scriptId = "kakao-adfit-script";
        if (document.getElementById(scriptId)) return;

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = "//t1.daumcdn.net/kas/static/ba.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, [adSlot]);

    const safeHeight = Math.max(height, 50);

    return (
        <div
            className={`flex w-full items-center justify-center overflow-hidden rounded-xl bg-slate-100/80 ${className}`}
            style={{ minHeight: safeHeight }}
        >
            {adSlot && !adSlot.startsWith("REPLACE_") && (
                <ins
                    className="kakao_ad_area"
                    style={{ display: "none", width: `${width}px`, height: `${height}px` }}
                    data-ad-unit={adSlot}
                    data-ad-width={width}
                    data-ad-height={height}
                />
            )}
        </div>
    );
}

